module.exports = __webpack_public_path__ + "img/叶坪红军无线电总队旧址.bdd9c05e.png";